export default "__VITE_ASSET__Sx2VFLkP__"